import { IAnnualReportTemplateDTO } from '../interfaces/annual-report-template-dto.interface';

export type UpdateAnnualReportTemplateIncomeTaxonomyIdDto = Pick<IAnnualReportTemplateDTO, 'id' | 'incomeTaxonomyId'>;
